import { request } from '@/utils/request'

//查询审核人
export function getAuditor(params, that) {
    return request({
        url: '/srm/procSentForm/auditors',
        data: {},
        params: params,
        that,
        method: 'get',
    })
}
//保存审核人
export function saveAuditor(data, that) {
    return request({
        url: '/srm/procSentForm/saveAuditors',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}